import styled from 'styled-components';

export const FormCustomCurrencyAmount = styled.div.attrs({
    className: 'form-custom-currency-amount',
})`
    .form-row .form-control-label {
        font-size: 1.2rem;
    }
`;
